import styled from "@emotion/styled";
import { FONTS } from "shared/styles/base";
import { truncate } from "shared/styles/mixin";

export const AllBrandsContainer = styled.div`
    height: 380px;
    width: 100%;
    margin-left: 29px;
    text-transform: initial;
    border-right: 1px solid #ccc;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    align-content: space-between;
    padding-top: 5px;

    .br-inner {
        column-count: 4;
    }
`;

export const BrandListContainer = styled.ul`
    list-style: none;
    margin: 0 0 10px 0;
    width: 100%;
    padding: 0;
    min-height: 1508px;
`;

export const BrandTitle = styled.li`
    color: #000000;
    font-size: 1.285rem;
    height: 34px;
    padding-left: 5px;
    display: flex;
    align-items: center;
`;

export const BrandItem = styled.li`
    ${truncate}
`;

export const BrandAnchor = styled.a`
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    font: 300 1rem/1.285 ${FONTS.CERA};
    padding-left: 15px;
    height: 34px;
    width: 100%;
    cursor: pointer;
    color: #000;

    &:hover {
        background-color: #ebecf0;
    }
`;
